import { Button, PageHeader } from 'antd'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  exportEmployeeInsertExample: () => Promise<void>
  exportEmployeeUpdateExample: () => Promise<void>
  isInsert: string | null
}

const ImportEmployeesPageHeader: FC<Props> = ({
  exportEmployeeInsertExample,
  exportEmployeeUpdateExample,
  isInsert,
}) => {
  const { t } = useTranslation()
  return (
    <PageHeader
      // eslint-disable-next-line react/jsx-key
      extra={[
        <Button
          key={'download'}
          onClick={isInsert === 'true' ? exportEmployeeInsertExample : exportEmployeeUpdateExample}
        >
          {t('components.pages.employees.imports.pageHeader.download')}
        </Button>,
      ]}
      ghost={false}
      title={
        isInsert === 'true'
          ? t('components.pages.employees.imports.pageHeader.importInsert')
          : t('components.pages.employees.imports.pageHeader.importOverWrite')
      }
    />
  )
}

ImportEmployeesPageHeader.displayName = 'ImportEmployeesPageHeader'
export default ImportEmployeesPageHeader
